import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withTranslation} from 'react-i18next';
import { withRouter } from 'react-router';
import * as actions from '../../store/actions'

import PDFList from './PDFList';
import PDFCreate from './PDFCreate';

class PDFContainer extends Component {

	state = {
		page:this.props.page
	}

	render() {
		const {page} = this.state;
		return(
			page === 'pdList' ?
				<PDFList {...this.props}/>
			: <PDFCreate {...this.props}/>
		)
	}
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : (msg) => dispatch(actions.loader(msg)),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))
  };
}

export default connect(null, mapDispatchToProps)(withRouter(withTranslation()(PDFContainer)));